module.exports = __webpack_public_path__ + "icon-restroom-shared.svg?999d5004b0b859afb8d8afefba0bea12";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-restroom-shared.svg
// module id = 629
// module chunks = 0